module.exports = __webpack_public_path__ + "img/CALDERA.24716586.jpg";